import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { MessageCircle } from "lucide-react";

function timeAgo(iso) {
  const sec = Math.max(1, Math.floor((Date.now() - new Date(iso).getTime()) / 1000));
  if (sec < 60) return "just now";
  if (sec < 3600) return `${Math.floor(sec / 60)}m`;
  if (sec < 86400) return `${Math.floor(sec / 3600)}h`;
  return `${Math.floor(sec / 86400)}d`;
}

export default function Messages() {
  const [threads, setThreads] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/threads").then((r) => setThreads(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-[calc(100vh-4rem)] max-w-3xl mx-auto px-5 sm:px-8 py-10">
      <div className="flex items-center gap-3 mb-6">
        <MessageCircle className="h-6 w-6 text-[#7C3AED]" />
        <h1 className="font-display text-3xl sm:text-4xl tracking-tight font-medium">Messages</h1>
      </div>

      {loading ? (
        <div className="text-[#6B7280]">Loading…</div>
      ) : threads.length === 0 ? (
        <div className="bg-white border border-[#E8E5F0] rounded-2xl p-10 text-center text-[#6B7280]">
          No messages yet. Start a conversation from any item's page.
        </div>
      ) : (
        <ul className="space-y-2" data-testid="threads-list">
          {threads.map((t) => (
            <li key={t.thread_id}>
              <Link to={`/messages/${encodeURIComponent(t.thread_id)}`}
                data-testid={`thread-${t.thread_id}`}
                className="block bg-white border border-[#E8E5F0] rounded-2xl p-4 hover:border-[#7C3AED]/50 transition-colors">
                <div className="flex items-center justify-between gap-3">
                  <div className="min-w-0">
                    <div className="flex items-center gap-2">
                      <span className="font-medium text-[#0F0F12] truncate">{t.other_name}</span>
                      {t.unread > 0 && (
                        <span className="inline-block min-w-5 h-5 px-1.5 rounded-full bg-[#7C3AED] text-white text-xs font-medium grid place-items-center"
                          data-testid="thread-unread">
                          {t.unread}
                        </span>
                      )}
                    </div>
                    <div className="text-xs text-[#6B7280] truncate mt-0.5">on "{t.item_title}"</div>
                    <div className="text-sm text-[#0F0F12] truncate mt-1">{t.last_body}</div>
                  </div>
                  <div className="text-xs text-[#6B7280] shrink-0">{timeAgo(t.last_at)}</div>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
